<ng-container
  *ngIf="
    { memberDetails: memberDetails$ | async, memberCard: memberCard$ | async, ecash: ecash$ | async } as memberInfo;
    else loadingRef
  "
>
  <div class="member-card text-white">
    @if (wallet) {
    <div class="membercard-wallet-container">
      <div class="member-card-wallet card rounded-4 gloss">
        <ng-container *ngIf="{ barcode: barcode$ | async } as member">
          <ng-container *ngIf="member.barcode.Barcode; else loadingRef">
            <div class="qrcode-wrapper">
              <qrcode
                [qrdata]="member.barcode.Barcode"
                [width]="131"
                [errorCorrectionLevel]="'M'"
                [elementType]="'svg'"
                [margin]="0"
              ></qrcode>
            </div>
          </ng-container>
        </ng-container>
        <ng-container *notInProductCode="productcode.SingleGameBuyer">
          <div class="scan-text text-center font-size-14 font-praktika-normal text-white mt-3">
            {{ 'barcode.description' | translate }}
          </div>
        </ng-container>

        <ng-container *inProductCode="productcode.SingleGameBuyer">
          <div class="scan-text text-center font-size-14 font-praktika-normal mt-3 text-white">
            {{ 'barcode.description.sgb' | translate }}
          </div>
        </ng-container>
      </div>
      <ng-container *notInProductCode="productcode.SingleGameBuyer">
        <ng-container *ngTemplateOutlet="cardBody; context: { $implicit: memberInfo }"></ng-container>
      </ng-container>
    </div>
    } @else {
    <ng-container *ngTemplateOutlet="cardHeader; context: { $implicit: memberInfo }"></ng-container>
    <ng-container *ngTemplateOutlet="cardBody; context: { $implicit: memberInfo }"></ng-container>
    }
  </div>
</ng-container>
<ng-template #loadingRef>
  <fgbcl-loading></fgbcl-loading>
</ng-template>
<ng-template #cardHeader let-memberInfo>
  <div class="member-card-header">
    <div class="member-card-title mb-3" [routerLink]="['/account']">
      <div class="name text-white">
        <span>{{ 'member.card.hello' | translate }}, </span><span>{{ memberInfo.memberDetails.FirstName }}</span>
      </div>
      <div class="material-icons text-secondary cursor-pointer" *ngIf="!isAccountPage">arrow_outward</div>
    </div>
    <div class="img-holder pe-0">
      <img
        class="rounded"
        [src]="
          'member-card/' + (memberInfo.memberCard.ProductCode | replaceSpacesWithHyphens | lowercase) + '.png' | contentAssetImage
        "
        draggable="false"
      />
    </div>
    <ng-container *inProductCode="productcode.SingleGameBuyer">
      <div class="img-holder pe-0">
        <div class="bg-secondary sgb-image-container rounded">
          <img class="rounded sgb-image" [src]="'logo/login-image.svg' | contentAssetImage" draggable="false" />
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>
<ng-template #cardBody let-memberInfo>
  <div class="member-card-body d-lg-flex">
    <ng-container *notInProductCode="productcode.SingleGameBuyer">
      <div class="member-card-values">
        <div class="values mt-3">
          <div class="widget-width" [ngClass]="{ hidden: memberInfo.memberCard.DiscountLevel <= 0 }">
            <div class="member-card-value gloss cursor-pointer" (click)="openModal()">
              <span class="material-symbols-outlined"> percent_discount </span>
              <div class="group-value">
                <div class="value">{{ memberInfo.memberCard.DiscountLevel }}%</div>
                <div class="title">
                  {{ 'member.card.discount.label' | translate }}
                </div>
              </div>
            </div>
          </div>

          <div class="widget-width">
            <div class="member-card-value gloss">
              <img class="claws-icon" [src]="'icons/claw-icon.svg' | contentAssetImage" />
              <div class="group-value">
                <div class="value">
                  {{ pointsBalance$ | async | number : '1.0-0' }}
                </div>
                <div class="title">{{ 'member.card.claws.label' | translate }}</div>
              </div>
            </div>
          </div>

          <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.ecash'">
            <ng-container *ngIf="memberInfo.ecash > 0">
              <div class="widget-width">
                <div class="member-card-value gloss money-container">
                  <span class="material-symbols-outlined"> money_bag </span>
                  <div class="group-value">
                    <div class="value">
                      {{ memberInfo.ecash | FortressCurrencyPipe : '$' }}
                    </div>
                    <div class="title">{{ 'member.card.grizzbucks.label' | translate }}</div>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
        <!--Direct Auth-->
        <ng-container *ifScreenSize="screenType.Desktop">
          <div class="mt-3">
            <fgb-ecash-button></fgb-ecash-button>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </div>

  <!--Direct Auth-->
  <ng-container *ifScreenSize="screenType.Mobile">
    <div class="mt-3">
      <fgb-ecash-button></fgb-ecash-button>
    </div>
  </ng-container>
</ng-template>
